<template>
  <b-container>
    <!-- Card -->
    <b-card class="signin-out mx-auto">
      <!-- Header -->
      <div class="d-flex flex-column align-items-center">
        <!-- Logo -->
        <img src="@/assets/images/spade-logo.png"
             id="logo">
        <!-- /Logo -->
        <br>
        <h1 class="card-title">Sign in</h1>
      </div>
      <!-- /Header -->
      <br>
      <!-- Form -->
      <b-form name="form"
              @submit.prevent="handleLogin">

        <!-- User ID -->
        <b-form-group>
          <label for="username">User ID</label>
          <b-form-input type="text"
                        name="username"
                        placeholder="example@gmail.com"
                        v-model="user.username"
                        v-validate="{ required: true }"/>
          <div class="alert-danger"
               role="alert"
               v-if="errors.has('username')">Username is required!
          </div>
        </b-form-group>
        <!-- /User ID -->

        <!-- Password -->
        <b-form-group>
          <label for="password">Password</label>
          <b-form-input type="password"
                        name="password"
                        placeholder="Password"
                        v-model="user.password"
                        v-validate="{ required: true }"/>
          <div class="alert-danger"
               role="alert"
               v-if="errors.has('password')">Password is required!
          </div>
        </b-form-group>
        <!-- /Password -->

        <!-- Buttons -->
        <b-form-group>
          <button class="btn btn-signin btn-block"
                  :disabled="loading">
            <span class="spinner-border spinner-border-sm"
                  v-show="loading"></span>
            <span v-show="!loading">Login</span>
          </button>
          <div class="d-flex justify-content-center align-item-center my-3">
            <router-link to="/signup"
                         class="">Sign Up
            </router-link>
          </div>
        </b-form-group>
        <!-- /Buttons -->

      </b-form>
      <!-- /Form -->
    </b-card>
    <!-- /Card---->
  </b-container>
</template>

<script>
export default {
  name: 'login',
  computed: {
    authenticated() {
      return this.$store.state.auth.status.authenticated;
    },
  },
  data() {
    return {
      user: {
        username: null,
        password: null
      },
      loading: false,
    };
  },
  methods: {
    async handleLogin() {
      this.loading = true;

      // Validate the login form
      let result = await this.$validator.validateAll();

      // If the validation failed, return
      if (!result) {
        this.loading = false;
        return;
      }

      try {
        // Log in
        await this.$store.dispatch('auth/login', this.user);

        let responseData = this.$store.getters['auth/currentUser'];
        let preferRole = responseData.preferRole;

        let referrer = this.$store.getters["auth/referrer"];
        if (referrer) {
          this.pushRoute(referrer)
          this.$store.commit('auth/setReferrer', null)
          return
        }

        // [23.05.17] 선호 역할이 존재하면 해당 페이지로 이동, 그렇지 않으면 권한에 따라 이동
        if (preferRole !== null) {
          if (preferRole === 'Administrator' && this.hasAnyRole('Administrator')) {
            this.pushRoute('/admin');
          } else if (preferRole === 'Surveyor' && this.hasAnyRole('Surveyor')) {
            this.pushRoute('/survey');
          } else if (preferRole === 'Chatterer' && this.hasAnyRole('Chatterer')) {
            this.pushRoute('/chatter');
          } else if (preferRole === 'ESG' && this.hasAnyRole('ESG')) {
            this.pushRoute('/esg');
          } else {
            this.loading = false;
            await this.showMessage('선호 권한 설정이 올바르지 않습니다. 관리자에게 문의해주세요.');
          }
        } else {
          // Redirect
          if (this.hasAnyRole('Supervisor')) {
            this.pushRoute('/admin');
          } else if (this.hasAnyRole('Administrator', 'Operator')) {
            this.pushRoute('/dashboard');
          } else if (this.hasAnyRole('Surveyor')) {
            this.pushRoute('/survey');
          } else if (this.hasAnyRole('Chatterer')) {
            this.pushRoute('/chatter');
          } else if (this.hasAnyRole('ESG')) {
            this.pushRoute('/esg');
          } else {
            this.loading = false;
            await this.showMessage('접근 가능한 페이지가 존재하지 않습니다. 관리자에게 권한 부여를 요청해주세요.');
          }
        }
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>